import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, renderSlot as _renderSlot, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

import { PropType, reactive, toRefs } from "vue";
import FetchRequest from "@/api/FetchRequest";
import Auth from "@/api/Auth";
import { ElMessage } from "element-plus";
import MessageType from "@/utils/MessageType";

interface VimData {
  host: string;
  headers: any;
}


export default /*#__PURE__*/_defineComponent({
  __name: 'Upload',
  props: {
  fileTypes: {
    type: Object as PropType<Array<string>>,
    required: true,
    default: null,
  },
  isImg: {
    type: Boolean,
    required: true,
    default: true,
  },
},
  emits: ["uploadSuccess"],
  setup(__props, { emit: emits }) {

const props = __props;


const beforeUpload = (file: any) => {
  let suffix = file.name.substring(file.name.lastIndexOf(".") + 1);
  let suffixes = props.fileTypes;
  let len = suffixes.filter((item) => {
    return item === suffix.toLowerCase();
  }).length;
  if (len === 0) {
    ElMessage.error("不支持的文件类型,仅支持：" + suffixes.join(","));
  }
  return len > 0;
};
const vimData = reactive<VimData>({
  host: FetchRequest.getHost(),
  headers: {
    "Access-Control-Allow-Origin": "*",
    Authorization: "Bearer " + Auth.getToken(),
  },
});

//上传成功回调
const handleSuccess = (res: any) => {
  emits(
    "uploadSuccess",
    props.isImg ? { url: res.url } : { url: res.url, fileName: res.fileName },
    props.isImg ? MessageType.image : MessageType.file
  );
};
const { host, headers } = toRefs(vimData);

return (_ctx: any,_cache: any) => {
  const _component_el_upload = _resolveComponent("el-upload")!

  return (_openBlock(), _createBlock(_component_el_upload, {
    action: _unref(host) + '/common/uploadMinio',
    headers: _unref(headers),
    "show-file-list": false,
    "on-success": handleSuccess,
    "before-upload": beforeUpload,
    style: {"display":"inline-block"}
  }, {
    default: _withCtx(() => [
      _renderSlot(_ctx.$slots, "default")
    ]),
    _: 3
  }, 8, ["action", "headers"]))
}
}

})